module.exports = __webpack_public_path__ + "static/media/Lisa.8c05792a.png";